{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Upgrade",
    "navBilling": "Billing"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Your tab. Your <em>dhikr</em>.<br />Elevated.",
    "subtitle": "Every feature you need for a more intentional day — from prayer times and AI verse reflection to weather and priority tasks — in one calm, beautiful new tab.",
    "comparison_aria": "Plan comparison",
    "free": {
      "tierLabel": "Current",
      "tierName": "Free",
      "freeLabel": "Always free",
      "list_aria": "Free plan features"
    },
    "pro": {
      "list_aria": "Pro plan features",
      "tierLabel": "Upgrade to",
      "tierName": "Pro",
      "pricePeriod": "/ month",
      "priceAlt": "or $39.99 / year"
    },
    "freeFeatures": {
      "clockDate": "Clock & date display",
      "verseOfDay": "Quran verse of the day",
      "dailyBackground": "Daily background photo",
      "qiblaCompass": "Qibla compass",
      "basicTasks": "Basic tasks"
    },
    "proFeatures": {
      "weatherForecast": "5-day weather forecast",
      "verseFavorites": "Save & browse verse favorites",
      "notesAi": "Notes with AI analysis",
      "priorityTasks": "Priority task management",
      "verseReflection": "Verse reflection with AI"
    },
    "plans": {
      "monthly": {
        "label": "Monthly",
        "price": "$4.99",
        "period": "/ month",
        "note": "Billed monthly"
      },
      "yearly": {
        "label": "Yearly",
        "price": "$39.99",
        "period": "/ year",
        "note": "Two months free",
        "badge": "Save 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Cancel anytime. Your access continues through the end of the billing period with no partial charges.",
    "billingPeriod_aria": "Billing period",
    "cta": "Continue to secure checkout",
    "ctaLoading": "Redirecting to checkout…",
    "promoManual": "Enter code {{code}} on the next page to get your discount.",
    "signingUpAs": "Signing up as {{account}}",
    "signedOutHint": "You'll sign in or create an account first.",
    "switchAccount": "Use a different account",
    "ctaOpening": "Opening secure checkout…",
    "signIn": {
      "dialog_aria": "Sign in to Rhemn",
      "context": "Sign in or create an account to continue to checkout.",
      "contextOffer": "Sign in or create an account to continue. Your first year is {{price}}."
    },
    "offer": {
      "founding": {
        "name": "Founding price"
      },
      "year25": {
        "name": "25% off your first year"
      },
      "periodFirstYear": "first year",
      "heroLine": "Your first year is {{price}}.",
      "codeLine": "{{name}} · code {{code}}",
      "then": "Then {{price}} / year. Cancel anytime.",
      "thenShort": "Then {{price}} / year",
      "endsOn": "Offer ends {{date}}.",
      "ended": "This offer ended on {{date}}. Pro is {{price}} / year.",
      "yearlyOnly": "The {{name}} applies to the yearly plan.",
      "notApplied": "We couldn't apply code {{code}}. It may have ended or reached its limit. Pro is {{price}} / year.",
      "ctaRegular": "Continue at {{price}} / year"
    },
    "alreadyPro": {
      "title": "You already have Pro",
      "bodyStripe": "{{account}} is on Rhemn Pro. There's nothing more to buy.",
      "bodyApple": "{{account}} is on Rhemn Pro through the App Store. Manage it in your Apple ID settings.",
      "manage": "Manage billing"
    },
    "trustSignals_aria": "Trust signals",
    "reassurance": {
      "secureCheckout": "Secure checkout via Stripe",
      "cancelAnytime": "Cancel anytime, no questions",
      "accessUntilEnd": "Access until period end"
    },
    "errors": {
      "restoreSession": "Could not restore your session. Please try again from the extension.",
      "checkoutFailed": "Failed to start checkout. Please try again.",
      "appSessionExpired": "Your session from the app expired. Sign in to continue.",
      "signInFailed": "Sign-in didn't complete. Please try again."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Unlocked features",
    "unlockedFeatures": {
      "weatherForecast": "5-day weather forecast",
      "verseFavorites": "Save and browse verse favorites",
      "notesAi": "Notes with AI analysis",
      "priorityTasks": "Priority task management",
      "verseReflection": "Verse reflection with AI"
    },
    "success": {
      "title": "Welcome to Pro",
      "desc": "Your subscription is active. Sign in to Rhemn with this account and every Pro feature is there.",
      "addToChrome": "Add Rhemn to Chrome",
      "viewBilling": "View billing details",
      "closeTab": "Close this tab"
    },
    "cancel": {
      "title": "Checkout canceled",
      "desc": "No worries — your plan was not changed and you have not been charged. You can upgrade whenever you’re ready.",
      "backToUpgrade": "Back to upgrade",
      "returnToExtension": "Return to extension"
    }
  },
  "billing": {
    "title": "Billing",
    "subtitle": "Manage your subscription and view payment history.",
    "subscription_aria": "Subscription status",
    "subscriptionTitle": "Subscription",
    "loading_aria": "Loading billing information",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "Active",
      "trialing": "Free trial",
      "past_due": "Past due",
      "unpaid": "Unpaid",
      "canceled": "Canceled",
      "incomplete": "Incomplete",
      "none": "No subscription"
    },
    "planValues": {
      "proYearly": "Pro · Yearly",
      "proMonthly": "Pro · Monthly"
    },
    "warnings": {
      "paymentFailedTitle": "Payment failed",
      "paymentFailedDesc": "Your last payment did not go through. Update your payment method via Manage Billing to keep Pro access.",
      "trialEndingTitle": "Trial ending soon",
      "trialEndingToday": "Your free trial ends today on {{date}}. Add a payment method to keep your Pro features.",
      "trialEndingInDays_one": "Your free trial ends in {{count}} day on {{date}}. Add a payment method to keep your Pro features.",
      "trialEndingInDays_other": "Your free trial ends in {{count}} days on {{date}}. Add a payment method to keep your Pro features."
    },
    "cancellationScheduled": "Cancellation scheduled. You keep full Pro access until <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Trial ends today",
      "trialDaysRemaining_one": "{{count}} day remaining in trial",
      "trialDaysRemaining_other": "{{count}} days remaining in trial",
      "renews": "Renews {{date}}",
      "accessUntil": "Access until {{date}}"
    },
    "kv": {
      "status": "Status",
      "nextRenewal": "Next renewal",
      "trialEnds": "Trial ends",
      "trialDaysLeft_one": "{{count}} day left",
      "trialDaysLeft_other": "{{count}} days left",
      "endsToday": "ends today",
      "plan": "Plan"
    },
    "upgradeNudge": {
      "title": "Unlock Pro features",
      "desc": "Weather, prayer times, AI verse reflection and more — $4.99/month or $39.99/year.",
      "cta": "Upgrade"
    },
    "actions": {
      "manageBilling": "Manage billing & payment method",
      "cancelConfirmTitle": "Cancel your subscription?",
      "cancelConfirmDesc": "You’ll keep full Pro access through the end of your current billing period. No partial refunds are issued.",
      "canceling": "Canceling…",
      "yesCancel": "Yes, cancel",
      "keepPro": "Keep Pro",
      "cancelSubscription": "Cancel subscription"
    },
    "noSubscription": "No subscription found.",
    "paymentHistory_aria": "Payment history",
    "paymentHistoryTitle": "Payment history",
    "invoices_aria": "Invoices",
    "invoiceView": "View",
    "invoiceView_aria": "View invoice from {{date}}",
    "noInvoices": "No invoices yet.",
    "dangerZone_aria": "Danger zone",
    "dangerZoneTitle": "Danger zone",
    "deleteAccountTitle": "Delete account",
    "deleteAccountDesc": "Permanently delete your account and all associated data — tasks, notes, favorites, and billing history. This action cannot be undone.",
    "deleteAccountBtn": "Delete account",
    "deleteConfirm": {
      "warning": "This will immediately and permanently:",
      "list": {
        "deleteContent": "Delete all your tasks, notes, and favorited verses",
        "cancelSubscription": "Cancel any active subscription (no refund for unused time)",
        "removeAccount": "Remove your account from our database",
        "signOut": "Sign you out of all devices"
      },
      "typeToConfirm": "Type <strong>DELETE</strong> to confirm",
      "inputPlaceholder": "DELETE",
      "deleting": "Deleting…",
      "confirmBtn": "Permanently delete my account",
      "cancelBtn": "Cancel"
    },
    "errors": {
      "loadFailed": "Failed to load billing information.",
      "cancelFailed": "Failed to cancel subscription.",
      "deleteFailed": "Failed to delete account. Please try again or contact support.",
      "portalFailed": "Failed to open billing portal."
    }
  },
  "privacy": {
    "tocLabel": "Privacy Policy",
    "toc_aria": "Table of contents",
    "lastUpdated": "Last updated<br />September 22, 2026",
    "sections": {
      "overview": "Overview",
      "informationWeCollect": "Information We Collect",
      "connectedServices": "Connected Services (Google, Todoist, Apple)",
      "howWeUse": "How We Use Your Information",
      "howWeShare": "How We Share Your Information",
      "dataRetention": "Data Retention",
      "yourRights": "Your Privacy Rights",
      "california": "California Residents (CCPA/CPRA)",
      "cookies": "Cookies & Local Storage",
      "security": "Data Security",
      "changes": "Changes to This Policy",
      "contact": "Contact Us"
    },
    "headings": {
      "informationWeCollect": "Information We Collect",
      "connectedServices": "Connected Services (Google, Todoist, Apple)",
      "howWeUse": "How We Use Your Information",
      "howWeShare": "How We Share Your Information",
      "dataRetention": "Data Retention",
      "yourRights": "Your Privacy Rights",
      "california": "California Residents (CCPA / CPRA)",
      "cookies": "Cookies & Local Storage",
      "security": "Data Security",
      "changes": "Changes to This Policy",
      "contact": "Contact Us"
    }
  },
  "deleteAccount": {
    "intro": "Deleting your account permanently removes:",
    "list": {
      "account": "Your account and profile",
      "tasks": "All tasks",
      "notes": "All notes",
      "verses": "Saved Verses",
      "billing": "Subscription records"
    },
    "irreversible": "This cannot be undone.",
    "appleNotice": "Deleting your account does not cancel a subscription purchased through the App Store. Please also cancel it in Settings → Apple ID → Subscriptions.",
    "manageSubscription": "Manage subscription",
    "continueBtn": "Continue to delete",
    "keepBtn": "Keep my account",
    "confirmTitle": "Delete your account?",
    "confirmDesc": "Your account and all of its data will be permanently deleted. This cannot be undone.",
    "confirmBtn": "Permanently delete my account",
    "deleting": "Deleting…",
    "error": "We couldn't delete your account. Please check your connection and try again."
  }
}
